import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconImport",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, p, _, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--import"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Import",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    i("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.94 2.44A1.5 1.5 0 0 1 2 2h2a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 9h8a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 3H8a.5.5 0 0 1 0-1h2a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 10H2A1.5 1.5 0 0 1 .5 8.5v-5c0-.398.158-.78.44-1.06Z",
      fill: "currentColor"
    }, null, -1),
    i("path", {
      d: "M6 1a.5.5 0 0 1 .5.5v4.793l1.146-1.147a.5.5 0 1 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L5.5 6.293V1.5A.5.5 0 0 1 6 1Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const A = /* @__PURE__ */ s(c, [["render", u]]);
export {
  A as default
};
//# sourceMappingURL=import.js.map
